import { DataService } from './data.service';
import { EndPointService } from './end-point.service';
import { DialogService } from './dialog.service';
import { FireValidatorsService } from './fire-validators.service';
import { AutoLogoutService } from './autoLogout.service';
import { PrintService } from './print.service';
import { MappingService } from './mapping.service';
import { FireStorageService } from './fire-storage.service';

export const APP_SERVICES = [
    DataService,
    EndPointService,
    DialogService,
    FireValidatorsService,
    AutoLogoutService,
    PrintService,
    MappingService,
    FireStorageService
];
